import { render, staticRenderFns } from "./add-group.vue?vue&type=template&id=07971598"
import script from "./add-group.vue?vue&type=script&lang=js"
export * from "./add-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07971598')) {
      api.createRecord('07971598', component.options)
    } else {
      api.reload('07971598', component.options)
    }
    module.hot.accept("./add-group.vue?vue&type=template&id=07971598", function () {
      api.rerender('07971598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/group/add-group.vue"
export default component.exports